exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?modules&importLoaders=1!../../node_modules/postcss-loader/index.js!../style/breakpoints.css"), undefined);

// module
exports.push([module.id, "._34BhGXRgiDvDSk78wNzjBT,\n._3SrSIKpFvPVcJCP_yGV_RJ,\n.mUQvSfJFIaNbxTE07KmCf, ._3SrSIKpFvPVcJCP_yGV_RJ object, ._3SrSIKpFvPVcJCP_yGV_RJ embed {\n  font-weight: 500;\n  font-family: \"sofia-pro\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  box-sizing: border-box;\n}\n\n._34BhGXRgiDvDSk78wNzjBT {\n  display: block;\n  width: 100%;\n}\n\n@media " + require("-!../../node_modules/css-loader/index.js?modules&importLoaders=1!../../node_modules/postcss-loader/index.js!../style/breakpoints.css").locals["mediumBp"] + " {\n  ._34BhGXRgiDvDSk78wNzjBT {\n    max-width: calc(100%/12*8);\n  }\n}\n\n._3SrSIKpFvPVcJCP_yGV_RJ {\n  position: relative;\n  padding-bottom: 56.25%;\n  height: 0;\n  max-width: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n\n.mUQvSfJFIaNbxTE07KmCf, ._3SrSIKpFvPVcJCP_yGV_RJ object, ._3SrSIKpFvPVcJCP_yGV_RJ embed {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n", ""]);

// exports
exports.locals = {
	"mediumBp": "" + require("-!../../node_modules/css-loader/index.js?modules&importLoaders=1!../../node_modules/postcss-loader/index.js!../style/breakpoints.css").locals["mediumBp"] + "",
	"componentContainer": "_34BhGXRgiDvDSk78wNzjBT",
	"videoContainer": "_3SrSIKpFvPVcJCP_yGV_RJ",
	"video": "mUQvSfJFIaNbxTE07KmCf"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1!./~/postcss-loader!./src/Video/video.css
 ** module id = 486
 ** module chunks = 0
 **/